import React, { useState, useEffect } from 'react';
import { BookCoverVorlage } from "../../components/BookCoverVorlage";
import { Header } from "../../../components/Header";
import { Header_New } from '../../../components/Header_new/Header_new';
import { Link } from 'react-router-dom';
import "./style.css";
import axios from 'axios';
import AOS from 'aos';
import { getAnalytics, logEvent } from "firebase/analytics";

const Bcher = () => {
  const analytics = getAnalytics();
  logEvent(analytics, 'bookchoice');
  const [books, setBooks] = useState([]);
  const [booksByTopic, setBooksByTopic] = useState({});
  const [error, setError] = useState(null);
  
  useEffect(() => {
    axios.get('https://picked-chigger-top.ngrok-free.app/get_books/', {
      headers: {
        'ngrok-skip-browser-warning': 'true'
      }
    })
    .then(response => {
      setBooks(response.data);
      console.log(response.data);
      const booksSortedByTopic = response.data.reduce((acc, book) => {
        acc[book.topic] = acc[book.topic] ? [...acc[book.topic], book] : [book];
        return acc;
      }, {});
      setBooksByTopic(booksSortedByTopic);
    })
    .catch(error => {
      console.error('Error fetching data: ', error);
      setError('Fehler beim Laden der Bücher. Bitte versuchen Sie es später erneut.');
    });
  }, []);

  return (
    <div className="bcher">
      <Header_New />
      <div className="main-content"> 
        {error && <div className="error-message">{error}</div>}
        {Object.keys(booksByTopic).map(topic => (
          <div key={topic}>
            <h2 className="topic-header">{topic}</h2> {/* Topic Header */}
            <div className="book-grid">
              {booksByTopic[topic].map(book => (
                  <BookCoverVorlage 
                    buch={book}
                  />
              ))}
            </div>
          </div>
        ))}
      </div>
      <button  
        className="general-button"
        onClick={() => window.open('https://docs.google.com/forms/d/e/1FAIpQLSep9OlBga89c2ViFeKtdqMPEfH8eci-DwwAPZ9K8KbZh39UYA/viewform', '_blank', 'noopener,noreferrer')}
        >Reiche deine eigene Geschichte ein.</button>
      <div className="mobile-warning">
        Bitte drehen Sie ihr Gerät.<img src="https://firebasestorage.googleapis.com/v0/b/weread-45736.appspot.com/o/background%2FturnLandscape.png?alt=media&token=5c863abc-d04b-4bb1-9639-53b4056b88f5" alt="Turn Device"></img>
      </div>
    </div>
  );
};

export default Bcher;